module.exports = __webpack_public_path__ + "media/images/icons/bin-fa438697f67858fe3786a8da5ac3b258.svg";